import { useEffect, useState } from "react";
import { mailboxApi } from "@/lib/api";

let cache = null;
const subs = new Set();

export const reloadMailboxTopics = () =>
  mailboxApi.topics().then((r) => {
    cache = r.data;
    subs.forEach((fn) => fn(cache));
    return cache;
  });

export function useMailboxTopics() {
  const [topics, setTopics] = useState(cache || []);
  useEffect(() => {
    subs.add(setTopics);
    if (!cache) reloadMailboxTopics().catch(() => {});
    return () => subs.delete(setTopics);
  }, []);
  return topics;
}
